import React from 'react';
import { Star } from 'lucide-react';

interface Review {
  id: string;
  customerName: string;
  productName: string;
  rating: number;
  comment: string;
  date: string;
}

const reviews: Review[] = [
  {
    id: '1',
    customerName: 'Simran Dhiraj Tolani',
    productName: 'Laxmi Shankh',
    rating: 5,
    comment: 'Very beautiful and lovely shankh. I have done the same how it was written on ur website and offered to Maa Laxmi',
    date: '01/13/2026',
  },
  {
    id: '2',
    customerName: 'Versha Tyagi',
    productName: 'Dainik Puja Kit',
    rating: 5,
    comment: 'This Pooja Kit simplified my daily pooja process, just open the box and start. I sent this as a gift to my mumma.',
    date: '09/10/2025',
  },
  {
    id: '3',
    customerName: 'Arun',
    productName: 'Rajmohini',
    rating: 5,
    comment: 'Truly amazing product. I can feel the positivity around me and be more confident starting my day. I would recommend this for everyone.',
    date: '09/09/2025',
  },
  {
    id: '4',
    customerName: 'Vinay Lal Verma',
    productName: 'Kuber Potli',
    rating: 5,
    comment: 'I ordered this for my home temple, it\'s nice packaging and included everything that i want. 😃 must go for it 👍🏻',
    date: '09/09/2025',
  },
  {
    id: '5',
    customerName: 'Bhim Singh',
    productName: 'Natural Forest Honey',
    rating: 5,
    comment: 'Soothing Fragrance, Great Quality. I recently purchased Incense Sticks and am Happy with their scent and performance',
    date: '06/29/2023',
  },
  {
    id: '6',
    customerName: 'Sumit',
    productName: 'Dainik Puja Kit',
    rating: 5,
    comment: 'All daily pooja needs in one box. I recently purchased Kit and am Happy with their kit praparation, days wise specialally vidhi part',
    date: '06/29/2023',
  },
];

export const ReviewsSection: React.FC = () => {
  return (
    <section className="bg-background py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-primary/75">Testimonials</p>
          <h2 className="mb-4 mt-3 text-4xl font-bold text-text">
            Let customers <span className="text-primary">speak for us</span>
          </h2>
          <p className="text-charcoal/75">from {reviews.length} reviews</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="rounded-[24px] border border-primary/10 bg-secondary/45 p-6 transition-shadow hover:shadow-[0_16px_36px_rgba(13,13,13,0.08)]"
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    size={16}
                    className={`${
                      star <= review.rating
                        ? 'fill-accent text-accent'
                        : 'text-primary/15'
                    }`}
                  />
                ))}
              </div>

              <p className="mb-4 leading-relaxed text-charcoal">{review.comment}</p>

              <div className="border-t border-primary/10 pt-4">
                <p className="text-sm font-semibold text-text">{review.customerName}</p>
                <p className="mt-1 text-xs text-primary">{review.productName}</p>
                <p className="mt-2 text-xs text-charcoal/55">{review.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
